import { FC, useEffect } from "react";
import { Stock } from "@/models/stock";
import { classNames } from "@/lib/utils";
import StockChart from "@/components/ortex-charts/StockChart";
import styles from "./StockShortsInterestChart.module.scss";

interface PropsTypes {
    stock: Stock;
    officialReports?: boolean;
    isOnCustomViews?: boolean;
    /** The old chart offered an "Advanced" toggle here; the data picker now carries every series the tier allows. */
    setButton?: (component: any) => void;
}

/**
 * The short-interest chart on custom views and the official-reports tab: the
 * stock chart in `shorts` mode, so it shares the saved lines, scales and
 * template of the short-interest pages.
 */
const StockShortsInterestChart: FC<PropsTypes> = ({ stock, officialReports, isOnCustomViews, setButton }) => {
    useEffect(() => {
        setButton && setButton(<></>);
    }, [setButton]);

    return (
        <div className={classNames(styles["chart-container"], isOnCustomViews ? styles.customViews : "")}>
            <StockChart key={stock.tradingitem_id} stock={stock} mode="shorts" chartId={officialReports ? "official-reports" : "short-interest"} officialReports={officialReports} />
        </div>
    );
};

export default StockShortsInterestChart;
